import {createDatatableColumnRegistry} from "@/src/modules/core/lib/datatable-columns";

export const SHIFTS_MANAGE_TABLE_COLUMN_IDS = [
  "type",
  "officer",
  "properties",
  "from",
  "to",
  "status",
  "created",
  "start_time_status",
  "admin_action",
  "breaks_taken",
] as const;

export type ShiftsManageTableColumnId = (typeof SHIFTS_MANAGE_TABLE_COLUMN_IDS)[number];

const COLUMN_DEFS = [
  {id: "type", label: "Type", defaultVisible: true, widthRem: 5.5},
  {id: "officer", label: "Officer", defaultVisible: true, widthRem: 11},
  {id: "properties", label: "Properties", defaultVisible: true, widthRem: 14},
  {id: "from", label: "From", defaultVisible: true, widthRem: 9.5},
  {id: "to", label: "To", defaultVisible: true, widthRem: 9.5},
  {id: "status", label: "Status", defaultVisible: true, widthRem: 7.5},
  {id: "created", label: "Created", defaultVisible: false, widthRem: 9.5},
  {id: "start_time_status", label: "Start Time Status", defaultVisible: false, widthRem: 7.5},
  {
    id: "admin_action",
    label: "Admin action",
    defaultVisible: false,
    widthRem: 4.5,
  },
  {id: "breaks_taken", label: "Breaks taken", defaultVisible: false, widthRem: 4.5},
] as const satisfies readonly {
  id: ShiftsManageTableColumnId;
  label: string;
  defaultVisible: boolean;
  widthRem: number;
}[];

export const shiftsManageTableColumns = createDatatableColumnRegistry(
  SHIFTS_MANAGE_TABLE_COLUMN_IDS,
  COLUMN_DEFS,
);

export const getAvailableShiftsManageTableColumns = shiftsManageTableColumns.getAvailableColumns;
export const getShiftsManageTableColumnDef = shiftsManageTableColumns.getColumnDef;
export const getOrderedVisibleShiftsManageColumns =
  shiftsManageTableColumns.getOrderedVisibleColumns;
export const sumVisibleShiftsManageColumnWidthRem =
  shiftsManageTableColumns.sumVisibleColumnWidthRem;
